/* global window */
export const cssPrefix = 'x-spreadsheet';
export const dpr = window.devicePixelRatio || 1;
export default {
  cssPrefix,
  dpr,
};
export const TEXT_AREA_HEIGHT = "207px";
export const TEXT_AREA_HEIGHT_VALUE = 207;